import { DateTime } from 'luxon';
import { DateObject } from 'react-multi-date-picker';
import {
  dateObjectToDateTime,
  dateTimeToDateObject,
} from 'shared/components/shift-forms/components/shift-multiply-calendar/multi-date-object-utils';
export const isoDateStringToDateTime = (date: string): DateTime =>
  DateTime.fromISO(date).startOf('day');

export const dateTimeToIsoDateString = (date: DateTime): string => date.toISODate() ?? '';

export const isoDateStringsToDateObjects = (dates: string[]): DateObject[] =>
  dates.map(isoDateStringToDateTime).map(dateTimeToDateObject);

export const dateObjectsToIsoDateStrings = (dates: DateObject[]): string[] =>
  dates
    .map(dateObjectToDateTime)
    .map(dateTimeToIsoDateString)
    .sort((firstDate, secondDate) => firstDate.localeCompare(secondDate));

export const getCalendarMinAvailableDate = (
  allowsPast: boolean,
  anchorDate: DateTime = DateTime.now().startOf('day')
): DateTime | null => (allowsPast ? null : anchorDate);
